import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const CardPrimeiroConvidado = styled.div`
    display: flex;
    justify-content: center;
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    background-color: ${props => props.theme.colors.warning};
    color: ${props => props.theme.colors.white};
    font-size: 20px;
`

export const FormGroup = styled.div`
    display: flex;
`

export const Totalizador = styled.h2`
    display: flex;
    justify-content: center;
    color: ${props => props.theme.colors.white};
`